import { Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Building2, LogOut, Menu } from "lucide-react";
import Sidebar from "../components/Sidebar";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const companyName = user.company_name || user.company || user.name || "บริษัทของคุณ";
  const displayName = user.name || user.username || `App ID: ${user.app_id || "—"}`;

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex bg-gray-50">

      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Content */}
      <div className="flex-1 min-w-0 flex flex-col">

        {/* Sticky top header */}
        <header className="sticky top-0 z-30 flex h-16 items-center border-b border-slate-200/80 bg-white/95 px-3 shadow-sm backdrop-blur sm:px-5">
          <button
            onClick={() => setSidebarOpen(true)}
            className="rounded-lg p-2 text-slate-600 transition hover:bg-slate-100 md:hidden"
            aria-label="เปิดเมนู"
          >
            <Menu size={20} />
          </button>

          <div className="ml-2 min-w-0 md:ml-0">
            <p className="truncate text-sm font-bold tracking-tight text-slate-800 md:hidden">
              PIXELS AI
            </p>
            <p className="hidden text-xs font-semibold uppercase tracking-[0.16em] text-slate-400 md:block">
              Customer Dashboard
            </p>
          </div>

          <div className="ml-auto flex min-w-0 items-center gap-2">
            <div className="flex min-w-0 items-center gap-2.5 rounded-xl border border-slate-200 bg-slate-50/80 px-2.5 py-1.5 sm:px-3">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#00b3b4]/10 text-[#008f90]">
                <Building2 size={16} />
              </div>
              <div className="min-w-0">
                <p
                  className="max-w-[120px] truncate text-xs font-semibold text-slate-800 sm:max-w-[220px] sm:text-sm"
                  title={companyName}
                >
                  {companyName}
                </p>
                <p className="hidden max-w-[220px] truncate text-xs text-slate-400 sm:block">
                  {displayName}
                </p>
              </div>
            </div>

            <button
              onClick={logout}
              className="flex h-11 shrink-0 items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-3 text-sm font-medium text-slate-600 transition hover:border-red-200 hover:bg-red-50 hover:text-red-600"
              title="ออกจากระบบ"
              aria-label="ออกจากระบบ"
            >
              <LogOut size={17} />
              <span className="hidden lg:inline">ออกจากระบบ</span>
            </button>
          </div>
        </header>

        {/* Page */}
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
